import React, {Component} from "react";
import "../../css/index.css";
import "../../css/login.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faUnlockAlt} from "@fortawesome/free-solid-svg-icons";
import {Col, Container, Form, Modal, Row} from '@themesberg/react-bootstrap';

import {BeatLoader} from "react-spinners";
import {Routes} from "../../routes";
import {connect} from "react-redux";
import login from "../../actions/auth";


export class Login extends Component {
    state = {
        username: "",
        password: "",
        error: false,
        showModal: false,
        loading: false,
    };

    handleClose = () => {
        this.setState({showModal: false,});
    };
    
    handleShow = (data) => {
        this.setState({showModal: true,});
    }

    static getDerivedStateFromProps(props, state) {
        const {user} = props;
        if (user) {
            window.location = Routes.DashboardOverview.path;
        }
        return state;
    }

    handleChange = (e) => {
        e.preventDefault();
        const {name, value} = e.target;
        this.setState(() => ({
            [name]: value,
        }));
    };

    login = async (e) => {
        e.preventDefault();
        this.setState({loading: true});
        const {username, password} = this.state;
        const {login} = this.props;
        const loginSuccess = await login({username, password});
        
        if (loginSuccess) {
            window.location = Routes.DashboardOverview.path;
        } else {
            this.setState(() => ({error: true}));
        }
        this.setState({loading: false});
    };

    render() {
        const {username, password, error, loading, showModal} = this.state;
        
        return (
            <main className="login-page">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8} xl={6}>
                            {/* Logo */}
                            <div className="login-logo-container">
                                <img 
                                    src="/intelligra-logo-f1.png" 
                                    alt="Finance 1 Logo" 
                                    className="login-logo"
                                />
                            </div>

                            {/* Login Card */}
                            <div className="login-card">
                                {/* Header */}
                                <div className="login-header">
                                    <h1 className="login-title">Welcome</h1>
                                </div>

                                {/* Error Message */}
                                {error && (
                                    <div className="login-error">
                                        <i className="fas fa-exclamation-circle me-2"></i>
                                        Incorrect username or password. Please try again.
                                    </div>
                                )}

                                {/* Login Form */}
                                <Form onSubmit={this.login}>
                                    {/* Username Field */}
                                    <div className="login-input-group">
                                        <label htmlFor="username">Username</label>
                                        <div className="login-input-wrapper">
                                            <FontAwesomeIcon 
                                                icon={faEnvelope} 
                                                className="login-input-icon"
                                            />
                                            <input
                                                id="username"
                                                type="text"
                                                name="username"
                                                className="login-input"
                                                placeholder="Enter your username"
                                                value={username}
                                                onChange={this.handleChange}
                                                autoFocus
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Password Field */}
                                    <div className="login-input-group">
                                        <label htmlFor="password">Password</label>
                                        <div className="login-input-wrapper">
                                            <FontAwesomeIcon 
                                                icon={faUnlockAlt} 
                                                className="login-input-icon"
                                            />
                                            <input
                                                id="password"
                                                type="password"
                                                name="password"
                                                className="login-input"
                                                placeholder="Enter your password"
                                                value={password}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* Remember Me & Forgot Password */}
                                    <div className="login-options">
                                        <div className="login-checkbox">
                                            <input 
                                                type="checkbox" 
                                                id="rememberMe"
                                            />
                                            <label htmlFor="rememberMe">
                                                Remember me
                                            </label>
                                        </div>
                                        <span 
                                            onClick={this.handleShow} 
                                            className="login-forgot-link"
                                        >
                                            Forgot password?
                                        </span>
                                    </div>

                                    {/* Submit Button */}
                                    <button
                                        type="submit"
                                        className="login-button"
                                        disabled={!username || !password || loading}
                                    >
                                        {loading ? (
                                            <span className="login-button-spinner">
                                                <BeatLoader color="#FFF" size={8} />
                                            </span>
                                        ) : (
                                            "Sign In"
                                        )}
                                    </button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>

                {/* Forgot Password Modal */}
                <Modal
                    show={showModal}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                    className="login-modal"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <i className="fas fa-key me-2"></i>
                            Forgot Password?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="alert alert-warning">
                            <i className="fas fa-info-circle me-2"></i>
                            If you've forgotten your password, please contact your system administrator for assistance.
                        </div>
                    </Modal.Body>
                </Modal>
            </main>
        );
    }
}

const mapStateToProps = (state) => {
    const {user, authError, role} = state.authentication;
    return {user, authError, role}; 
};

export default connect(mapStateToProps, {login})(Login);
